import { Chip as MuiChip } from '@material-ui/core'
import { CheckCircle, Error as ErrorIcon, Info, Warning, XCircle } from '@popmenu/web-icons'
import React from 'react'
import { ChipProps, DefaultChipComponent } from './ChipProps'
import { useChipStyles } from './ChipStyles'

const IconDictionary = {
  error: ErrorIcon,
  info: Info,
  success: CheckCircle,
  warning: Warning,
}

export const Chip = <C extends React.ElementType = DefaultChipComponent>(props: ChipProps<C>) => {
  const { severity, ...restProps } = props
  const classes = useChipStyles(props)
  const icon = severity ? React.createElement(IconDictionary[severity]) : undefined
  const deleteIcon = React.createElement(XCircle)
  return <MuiChip classes={classes} icon={icon} deleteIcon={deleteIcon} {...restProps} />
}

Chip.displayName = 'Chip'
